namespace TabAurous.Production {
    export interface JobWorkIssueItemsRow {
        TransItemId?: number;
        TransId?: number;
        TransDate?: string;
        PartyId?: number;
        VoucherTypeId?: number;
        VoucherNo?: string;
        OrderTypeId?: number;
        OrderTransId?: number;
        OrderTransItemId?: number;
        ProductId?: number;
        ProductCode?: string;
        OrderNo?: string;
        CustomerName?: string;
        AttributeId?: number;
        Attribute?: string;
        BagNo?: string;
        LotNo?: string;
        SubBagNo?: number;
        Line_No?: number;
        Parts?: number;
        FromPieces?: number;
        FromWeight?: number;
        FromNetWeight?: number;
        Purity?: number;
        PureWeight?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        FromDeptId?: number;
        FromWorkerId?: number;
        LossPercent?: number;
        Loss?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        StartDateTime?: string;
        EndDateTime?: string;
        DepartmentId?: number;
        StockAllocation?: boolean;
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        CertificateNo?: string;
        Hallmark?: number;
        BOMDetails?: JobWorkIssueBOMRow[];
        NewBOMDetails?: Sales.MaterialOutItemsRow[];
        TreeId?: number;
        TreeItemId?: number;
        TreeNo?: string;
    }

    export namespace JobWorkIssueItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.JobWorkIssueItems';
        export const lookupKey = 'Production.JobWorkIssueItems';

        export function getLookup(): Q.Lookup<JobWorkIssueItemsRow> {
            return Q.getLookup<JobWorkIssueItemsRow>('Production.JobWorkIssueItems');
        }
        export const deletePermission = 'Production:JobWorkIssue:Delete';
        export const insertPermission = 'Production:JobWorkIssue:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkIssue:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            TransDate = "TransDate",
            PartyId = "PartyId",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            OrderTypeId = "OrderTypeId",
            OrderTransId = "OrderTransId",
            OrderTransItemId = "OrderTransItemId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            OrderNo = "OrderNo",
            CustomerName = "CustomerName",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            BagNo = "BagNo",
            LotNo = "LotNo",
            SubBagNo = "SubBagNo",
            Line_No = "Line_No",
            Parts = "Parts",
            FromPieces = "FromPieces",
            FromWeight = "FromWeight",
            FromNetWeight = "FromNetWeight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            FromDeptId = "FromDeptId",
            FromWorkerId = "FromWorkerId",
            LossPercent = "LossPercent",
            Loss = "Loss",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            StartDateTime = "StartDateTime",
            EndDateTime = "EndDateTime",
            DepartmentId = "DepartmentId",
            StockAllocation = "StockAllocation",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            BOMDetails = "BOMDetails",
            NewBOMDetails = "NewBOMDetails",
            TreeId = "TreeId",
            TreeItemId = "TreeItemId",
            TreeNo = "TreeNo"
        }
    }
}
